












































































































































































































import { Vue, Component, Ref, Emit, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import TournamentPlayers from './TournamentPlayers'
import TournamentTeamChangeCaptainDialog from '@/modules/tournament/components/TournamentTeamChangeCaptainDialog'
import EditTournamentGroupDialog from '../../EditTournamentGroupDialog'
import EditTournamentTeamMemberGameAccountDialog from '../../EditTournamentTeamMemberGameAccountDialog'
import EditTournamentFormResponseDialog from '../../EditTournamentFormResponseDialog'
import {
  TournamentAPI,
  TournamentEntity,
  TournamentState
} from '@/api/tournament'
import {
  TournamentTeamEntity,
  TournamentPlayerEntity,
  TournamentTeamState,
  TournamentTeamRole
} from '@/api/tournamentTeam'
import ServerError from '@/utils/server_error'
import userStore from '@/modules/auth/auth.store'
import tournamentStore from '@/modules/tournament/tournament.store'
import { HubConnection } from '@microsoft/signalr'
import { CancelError, CancellationToken } from '@/utils/cancel'
import { getRealtimeConnection, realtimeEventTarget } from '@/utils/realtime'
import i18n from '@/lang'
import { isElectron } from '@/utils/electron'

@Component({
  components: {
    TournamentPlayers,
    TournamentTeamChangeCaptainDialog,
    EditTournamentGroupDialog,
    EditTournamentFormResponseDialog,
    EditTournamentTeamMemberGameAccountDialog
  }
})
export default class TeamRegistrationStatus extends Vue {
  userModule = getModule(userStore, this.$store)
  tournamentModule = getModule(tournamentStore, this.$store)
  realtimeConnection!: HubConnection
  realtimeConnectionCancellationToken = new CancellationToken()

  teamToken: string = ''
  isGeneratingTeamToken: boolean = false
  isChangeTeamCaptainDialogVisible: boolean = false
  isEditTournamentGroupDialogVisible: boolean = false
  isEditGameAccountDialogVisible: boolean = false
  isTournamentResponseEditDialogVisible: boolean = false

  @Prop({ type: Boolean, default: false }) readonly isVisible!: boolean
  @Prop({ type: Boolean, default: false }) readonly hasCustomForm!: boolean

  @Ref('teamTokenTextField')
  readonly teamTokenTextField!: { $el: HTMLInputElement }

  @Ref('tournamentPlayers')
  readonly tournamentPlayers!: TournamentPlayers

  @Emit('close')
  onClose() {
    return this
  }

  @Watch('isVisible')
  async onVisibilityChanged(visible: boolean) {
    if (visible) {
      if (this.selectedTournamentTeam) {
        await this.realtimeConnection.send(
          'SubscribeTournamentTeam',
          this.selectedTournamentTeam.tournamentTeamId
        )
      }

      if (this.selectedTournament) {
        await this.tournamentModule.getMemberJoinedTournamentTeam(
          this.selectedTournament.tournamentId
        )
      }
    } else {
      if (this.selectedTournamentTeam) {
        await this.realtimeConnection.send(
          'UnsubscribeTournamentTeam',
          this.selectedTournamentTeam.tournamentTeamId
        )
      }
    }
  }

  async onGameAccountNameChanged() {
    if (this.selectedTournament) {
      await this.tournamentModule.getMemberJoinedTournamentTeam(
        this.selectedTournament.tournamentId
      )
    }
  }

  async onTournamentGroupChanged() {
    if (this.selectedTournament) {
      await this.tournamentModule.getMemberJoinedTournamentTeam(
        this.selectedTournament.tournamentId
      )
    }
  }

  @Watch('selectedTournamentTeam')
  async onSelectedTournamentTeamChanged(
    selectedTournamentTeam: TournamentTeamEntity,
    oldSelectedTournamentTeam: TournamentTeamEntity
  ) {
    try {
      this.realtimeConnection = await getRealtimeConnection(
        this.realtimeConnectionCancellationToken
      )
    } catch (err) {
      if (err instanceof CancelError) {
        return
      }

      this.$toast.error(
        this.$t('TeamRegistrationStatus.FailConnectServerMessage')
      )
      console.error(err)
    }

    if (oldSelectedTournamentTeam) {
      await this.realtimeConnection.send(
        'UnsubscribeTournamentTeam',
        oldSelectedTournamentTeam.tournamentTeamId
      )
    }

    if (selectedTournamentTeam) {
      await this.realtimeConnection.send(
        'SubscribeTournamentTeam',
        selectedTournamentTeam.tournamentTeamId
      )
    } else {
      this.onClose()
    }
  }

  async confirmRoster() {
    await this.tournamentPlayers.onConfirmTournamentTeamRosterClick()
  }

  async created() {
    try {
      this.realtimeConnection = await getRealtimeConnection(
        this.realtimeConnectionCancellationToken
      )
    } catch (err) {
      if (err instanceof CancelError) {
        return
      }

      this.$toast.error(
        this.$t('TeamRegistrationStatus.FailConnectServerMessage')
      )
      console.error(err)
    }

    this.realtimeConnection.on(
      'tournamentPlayerAdded',
      this.onTournamentPlayerUpdated
    )
    this.realtimeConnection.on(
      'tournamentPlayerRemoved',
      this.onTournamentPlayerRemoved
    )
    this.realtimeConnection.on(
      'tournamentTeamRegistered',
      (memberIds: string[]) => this.onTournamentTeamRegistered(memberIds)
    )
    this.realtimeConnection.on(
      'tournamentTeamCaptainChanged',
      this.onTournamentTeamCaptainChanged
    )
    this.realtimeConnection.on(
      'tournamentPlayerUpdated',
      this.onTournamentPlayerUpdated
    )

    if (this.selectedTournament && this.selectedTournamentTeam) {
      await this.realtimeConnection.send(
        'SubscribeTournamentTeam',
        this.selectedTournamentTeam.tournamentTeamId
      )
    }

    realtimeEventTarget.addEventListener(
      'reconnected',
      this.onRealtimeReconnected
    )
  }

  async beforeDestroy() {
    this.realtimeConnectionCancellationToken.cancel()

    if (this.realtimeConnection) {
      this.realtimeConnection.off(
        'tournamentPlayerAdded',
        this.onTournamentPlayerUpdated
      )
      this.realtimeConnection.off(
        'tournamentPlayerRemoved',
        this.onTournamentPlayerUpdated
      )
      this.realtimeConnection.off(
        'tournamentTeamRegistered',
        this.onTournamentTeamRegistered
      )
      this.realtimeConnection.off(
        'tournamentTeamCaptainChanged',
        this.onTournamentTeamCaptainChanged
      )
      this.realtimeConnection.off(
        'tournamentPlayerUpdated',
        this.onTournamentPlayerUpdated
      )

      if (this.selectedTournament && this.selectedTournamentTeam) {
        await this.realtimeConnection.send(
          'UnsubscribeTournamentTeam',
          this.selectedTournamentTeam.tournamentTeamId
        )
      }
    }

    realtimeEventTarget.removeEventListener(
      'reconnected',
      this.onRealtimeReconnected
    )
  }

  onTournamentPlayerJoined(tournamentPlayer: TournamentPlayerEntity) {
    if (!this.selectedTournamentTeam) {
      return
    }

    this.tournamentModule.addPlayerToSelectedTournamentTeam(tournamentPlayer)
  }

  async onTournamentPlayerRemoved(tournamentPlayer: TournamentPlayerEntity) {
    if (!this.selectedTournamentTeam) {
      return
    }

    await this.fetchJoinedTournamentTeam()
  }

  onTournamentTeamRegistered(memberIds: string[]) {
    this.tournamentModule.setSelectedTournamentTeamRegistered(memberIds)
  }

  onTournamentTeamCaptainChanged() {
    this.$toast.info(this.$t('TeamRegistrationStatus.TeamCaptainUpdated'))
    this.onClose()
  }

  onTournamentPlayerUpdated() {
    this.fetchJoinedTournamentTeam()
  }

  async onRealtimeReconnected() {
    // ensure we have subscribed the tournament team
    if (this.selectedTournament && this.selectedTournamentTeam) {
      await this.realtimeConnection.send(
        'SubscribeTournamentTeam',
        this.selectedTournamentTeam.tournamentTeamId
      )
    }

    // fetch api for new data
    await this.fetchJoinedTournamentTeam()
  }

  captainChanged() {
    this.isChangeTeamCaptainDialogVisible = false
  }

  /* Vuex State */
  get selectedTournamentTeam(): TournamentTeamEntity | null {
    return this.tournamentModule.selectedTournamentTeam
  }

  get selectedTournament(): TournamentEntity | null {
    return this.tournamentModule.selectedTournament
  }

  get userId() {
    return this.userModule.userId
  }

  get isRegistrationPeriod(): boolean {
    if (!this.selectedTournament) return false

    return (
      this.selectedTournament.state === TournamentState.OpenRegistration ||
      this.selectedTournament.state === TournamentState.CompleteRegistration
    )
  }

  get isSoloTournament() {
    return (
      this.selectedTournament &&
      this.selectedTournament.capacityMaxPlayersPerTeam === 1
    )
  }

  get isTeamCaptain(): boolean {
    let tournamentTeam = this.selectedTournamentTeam
    if (tournamentTeam && tournamentTeam.players) {
      return tournamentTeam.players.some(
        (player: TournamentPlayerEntity) =>
          player.memberId === this.userId && player.role === 'Captain'
      )
    }
    return false
  }

  get step(): number {
    if (this.selectedTournamentTeam) {
      if (
        this.selectedTournamentTeam.state === TournamentTeamState.Registered
      ) {
        return 3
      }

      if (
        this.selectedTournamentTeam &&
        this.selectedTournamentTeam.players &&
        this.selectedTournamentTeam.players.filter(
          player => player.role !== TournamentTeamRole.RequestToJoin
        ).length >= this.selectedTournament!.capacityMinPlayersPerTeam
      ) {
        return 2
      }
    }

    return 1
  }

  get isAllowChangeCaptain() {
    if (!this.isTeamCaptain) return false
    if (!this.selectedTournamentTeam) return false
    if (!this.selectedTournament) return false
    const validTournamentStates = [
      TournamentState.Initial,
      TournamentState.Published,
      TournamentState.OpenRegistration,
      TournamentState.CompleteRegistration
    ]
    return (
      this.selectedTournamentTeam.players.filter(
        player => player.role === TournamentTeamRole.Member
      ).length >= 1 &&
      validTournamentStates.indexOf(this.selectedTournament.state) !== -1
    )
  }

  /* Methods */
  async generateTeamToken() {
    this.isGeneratingTeamToken = true

    try {
      const response = await TournamentAPI.refreshTeamToken(
        this.selectedTournamentTeam!.tournamentTeamId
      )
      this.teamToken = response.data.payload!
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        console.error(err)
      }

      this.teamToken = ''
    } finally {
      this.isGeneratingTeamToken = false
    }
  }

  copyTeamToken() {
    this.$copyText(this.teamTokenOutput, this.teamTokenTextField.$el).then(
      e => {
        this.$toast.success(
          this.$t('TeamRegistrationStatus.CopiedTeamCodeToClipboard')
        )
      },
      e => {
        this.$toast.error(
          this.$t('TeamRegistrationStatus.FailedToCopyToClipboard')
        )
      }
    )
  }

  copyTeamTokenUrl() {
    this.$copyText(this.teamTokenUrl, this.teamTokenTextField.$el).then(
      e => {
        this.$toast.success(
          this.$t('TeamRegistrationStatus.CopiedTeamCodeToClipboard')
        )
      },
      e => {
        this.$toast.error(
          this.$t('TeamRegistrationStatus.FailedToCopyToClipboard')
        )
      }
    )
  }

  /* Computed Properties */
  get teamTokenOutput() {
    if (this.teamToken.length === 6) {
      return this.teamToken
      // return this.teamToken!.substr(0, 3) + ' ' + this.teamToken!.substr(3)
    } else {
      return ''
    }
  }

  get teamTokenUrl() {
    if (this.isElectron) {
      return process.env.VUE_APP_TEAM_TOKEN_URL!.replace(
        '%teamToken%',
        this.teamTokenOutput.replace(' ', '')
      )
    }
    return `${window.location.origin}/invite/${this.teamToken}`
  }

  get isElectron() {
    return isElectron()
  }

  get hasGroup() {
    return (
      this.tournamentModule.selectedTournament &&
      this.tournamentModule.selectedTournament.hasGroup
    )
  }

  async onConfirmRoster() {
    await this.fetchJoinedTournamentTeam()
  }

  async onUnconfirmRoster() {
    await this.fetchJoinedTournamentTeam()
  }

  async fetchJoinedTournamentTeam() {
    try {
      await this.tournamentModule.getMemberJoinedTournamentTeam(
        this.selectedTournament!.tournamentId
      )
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('TeamRegistrationStatus.SystemErrorMessage'))
        console.error(err)
      }
    }
  }
}
